module.exports = __webpack_public_path__ + "static/media/-_Temporary Job.368e12d9.png";